import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  mode: "history",
  base: "/drama_pc",
  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    {
      name: "home",
      path: "/home",
      meta: {
        title: "首页"
      },
      component: () =>
        import(/* webpackChunkName: "orderconfirm" */ "./views/index/Index.vue")
    },
    //工会订单列表页
    {
      name: "unionList",
      path: "/order/unionorderlist",
      meta: {
        title: "工会订单列表"
      },
      component: () =>
        import(
          /* webpackChunkName: "unionList" */ "./views/showOrder/UnionOrderList.vue"
        )
    },
    //订单确认页
    {
      name: "orderconfirm",
      path: "/order/confirm",
      meta: {
        title: "订单确认"
      },
      component: () =>
        import(
          /* webpackChunkName: "orderconfirm" */ "./views/showOrder/Index.vue"
        )
    },
    //订单列表页
    {
      name: "orderlist",
      path: "/order/list",
      meta: {
        title: "订单列表"
      },
      component: () =>
        import(
          /* webpackChunkName: "orderconfirm" */ "./views/showOrder/OrderList.vue"
        )
    },
    //订单支付页
    {
      name: "orderpay",
      path: "/order/pay",
      meta: {
        title: "订单支付"
      },
      component: () =>
        import(
          /* webpackChunkName: "orderpay" */ "./views/showOrder/OrderPay.vue"
        )
    },
    //订单信息页
    {
      name: "orderinfo",
      path: "/order/info",
      meta: {
        title: "订单信息"
      },
      component: () =>
        import(
          /* webpackChunkName: "orderinfo" */ "./views/showOrder/OrderInfo.vue"
        )
    },
    //支付信息页
    {
      name: "payinfo",
      path: "/pay/info",
      meta: {
        title: "支付信息"
      },
      component: () =>
        import(
          /* webpackChunkName: "payinfo" */ "./views/showOrder/PayInfo.vue"
        )
    },
    //支付信息页
    {
      name: "logStics",
      path: "/logstics",
      meta: {
        title: "物流详情"
      },
      component: () =>
        import(/* webpackChunkName: "payinfo" */ "./views/logStics/Index.vue")
    },
    // 演出列表
    {
      name: "list",
      path: "/list",
      meta: {
        title: "演出列表"
      },
      component: () =>
        import(
          /* webpackChunkName: "orderconfirm" */ "./views/showList/Index.vue"
        )
    },
    // 演出详情
    {
      name: "detail",
      path: "/detail",
      meta: {
        title: "演出详情"
      },
      component: () =>
        import(
          /* webpackChunkName: "orderconfirm" */ "./views/showDetail/Index.vue"
        )
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});
